(() => {
  function init() {
    for (const video of document.querySelectorAll('.elementre-hero-video')) {
      if (video.dataset.autoplayReady) continue;
      video.dataset.autoplayReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.pause();
      let inView = false;
      let disposed = false;
      const nextUrl = video.closest('.elementre-video-hero')?.dataset.nextVideo;
      const play = () => {
        if (disposed || !inView || document.hidden) {
          video.pause();
          return;
        }
        const result = video.play();
        if (result) result.catch(() => {});
      };
      if (nextUrl) {
        const first = {
          sources: Array.from(video.querySelectorAll('source'), source => source.cloneNode(true)),
          src: video.getAttribute('src'),
          poster: video.getAttribute('poster'),
          label: video.getAttribute('aria-label')
        };
        let second = false;
        video.loop = false;
        video.removeAttribute('loop');
        video.addEventListener('ended', () => {
          second = !second;
          video.removeAttribute('src');
          video.removeAttribute('poster');
          video.removeAttribute('aria-label');
          if (second) {
            const source = document.createElement('source');
            source.src = nextUrl;
            source.type = 'video/mp4';
            video.replaceChildren(source);
          } else {
            video.replaceChildren(...first.sources.map(source => source.cloneNode(true)));
            if (first.src) video.setAttribute('src', first.src);
            if (first.poster) video.setAttribute('poster', first.poster);
            if (first.label) video.setAttribute('aria-label', first.label);
          }
          video.load();
          play();
        });
      }
      play();
      video.addEventListener('canplay', play, { once: true });
      const observer = new IntersectionObserver(entries => {
        inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .15);
        play();
      }, { threshold: .15 });
      observer.observe(video);
      const onVisibilityChange = () => play();
      document.addEventListener('visibilitychange', onVisibilityChange);
      const section = video.closest('.shopify-section');
      if (section) section.addEventListener('shopify:section:unload', () => {
        disposed = true;
        observer.disconnect();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        video.pause();
      }, { once: true });
    }
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
